import React, {useState, useEffect} from 'react'
import HeadingArea from '../../general/HeadingArea'
import ResponseMsg2 from '../../general/ResponseMsg2'
import { AiOutlinePlus } from 'react-icons/ai';
import { FaCheck, FaPlus } from 'react-icons/fa6';
import { FaMinus } from 'react-icons/fa';
import { AiOutlineSearch } from 'react-icons/ai';

const AssignSubjects = ({setLoading}) => {
      const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
   const [selectedClassId, setSelectedClassId] = useState('');
const [selectedSection, setSelectedSection] = useState('');
const [emp, setEmp] = useState([]);
const [subjects, setSubjects] = useState([]);
const [showForm, setShowForm] = useState(false);
const [assignments, setAssignments] = useState([
  { subject_id: '', teacher_id: '' }
]);

const fetchAssignSubject = async () => {
  if (!selectedClassId || !selectedSection) {
    setResponse2({ message: 'Please select class and section before searching', status: 'error' });
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${selectedClassId}&section=${selectedSection}`);

    if (res.ok) {
      const data = await res.json();

      if(data.length > 0){
      const mappedAssignments = data.map(item => ({
        id: item.id,
        subject_id: item.sub_id?.toString() || '',
        teacher_id: item.teacher_id?.toString() || '',
      }));

      setAssignments(mappedAssignments.length > 0 ? mappedAssignments : [{ subject_id: '', teacher_id: '' }]);

      setShowForm(true); 
      setResponse2({ message: 'Assigned Subjects Fetched Successfully', status: 'success' });
      }
      else {
        // setAssignments([{ subject_id: '', teacher_id: '' }]);
        setAssignments([]);
        setShowForm(false);
        setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch assigned subjects error:', error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};



           const fetchClasses = async () => {
                           setLoading(true);
                   try {
                       const response = await fetch('https://api.kcian.in/get-classes');
       
                       if (response.ok) {
                           const data = await response.json();
                           setClasses(data);
                           setLoading(false);

                       } else {
                           setLoading(false);
                           console.error('Failed to fetch class');
                       }
                   } catch (error) {
                       setLoading(false);
                       console.error('Error fetching data:', error);
                   }
     }

     
           const fetchSubjects = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-subjects');
        
                        if (response.ok) {
                            const data = await response.json();
                            setSubjects(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch class');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


               const fetchEmp = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-employee');
      
                      if (response.ok) {
                          const data = await response.json();
 const filteredData = data.filter(emp => emp.role == 'Teacher');
                          setEmp(filteredData);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch employee');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


     useEffect(() => {
  fetchClasses();
  fetchSubjects();
  fetchEmp();
}, []);


useEffect(() => {
  if (selectedClassId) {
const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));

    if (selectedClass && selectedClass.sections) {
      const sectionArray = selectedClass.sections
        .split(',')
        .map((s) => s.trim()) 
        .filter((s) => s !== '');

      setAvailableSections(sectionArray);
    } else {
      setAvailableSections([]);
    }

    setSelectedSection('');
  }
}, [selectedClassId, classes]);


const handleAddAssignment = () => {
  setAssignments([...assignments, { subject_id: '', teacher_id: '' }]);
};

// const handleRemoveAssignment = (index) => {
//   const updated = [...assignments];
//   updated.splice(index, 1);
//   setAssignments(updated);
// };
const deleteAssignmentFromBackend = async (id) => {
  try {
    const res = await fetch(`https://api.kcian.in/delete-assign-subject/${id}`, {
      method: 'DELETE',
    });

    if (res.ok) {
      return true;
    } else {
      const data = await res.json();
      setResponse2({ message: data.message || 'Failed to delete assignment.', status: 'error' });
            setTimeout(() => {
          setResponse2('');
        }, 3000);
              return false;
    }
  } catch (error) {
    console.error('Delete assignment error:', error);
    // setResponse2({ message: 'Error deleting assignment. Please try again.', status: 'error' });
    return false;
  }
};


const handleRemoveAssignment = async (index) => {
  const assignment = assignments[index];

  if (assignment.id) {
    const confirmDelete = window.confirm('Are you sure want to remove this assigned subject?');
    if (!confirmDelete) return;

    setLoading(true);
    const success = await deleteAssignmentFromBackend(assignment.id);
    setLoading(false);

    if (!success) return;
  }

  // Remove from UI regardless if new or after successful delete
  const updated = [...assignments];
  updated.splice(index, 1);
  setAssignments(updated);
};


const handleAssignmentChange = (index, field, value) => {
  const updated = [...assignments];
  updated[index][field] = value;
  setAssignments(updated);
};


const handleSubmit = async () => {
  if (!selectedClassId || !selectedSection) {
    setResponse2({ message: 'Please select class and section', status: 'error' });
    return;
  }

   const newAssignments = assignments.filter(a => !a.id);

  if (newAssignments.length === 0) {
    setResponse2({ message: 'No new assignments to save.', status: 'error' });
    return;
  }

  // Check each assignment is filled
  for (let a of newAssignments) {
    if (!a.subject_id || !a.teacher_id) {
      setResponse2({ message: 'Please fill all subject-teacher pairs', status: 'error' });
      return;
    }
  }

  const payload = newAssignments.map(({ subject_id, teacher_id }) => ({
    class_id: Number(selectedClassId),
    section: selectedSection,
    subject_id,
    teacher_id,
  }));

  try {
    setLoading(true);
    const res = await fetch('https://api.kcian.in/create-assign-subject', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (res.ok) {
      setResponse2({ message: data.message || 'Subjects Assigned Successfully', status: 'success' });
      setAssignments([{ subject_id: '', teacher_id: '' }]);
      setShowForm(false);
    } else {
      setResponse2({ message: data.message || 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    // setResponse2({ message: 'An error occurred. Please try again.', status: 'error' });
    console.error(error);
  } finally {
    setLoading(false);
            setTimeout(() => {
          setResponse2('');
        }, 3000);   
  }
};



  return (
    <> 
          <section className="py-4">
      <div className="px-4">
        <HeadingArea message1="Subjects" message2="Assign Subjects" />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<div className='profile-card'>

<div className='d-flex justify-content-between'>
              <span className="profile-heading align-content-center">Select Criteria</span>

              {assignments.length <= 0 && 
<button className='profile-btn' onClick={() => {setShowForm(true); setAssignments([
  { subject_id: '', teacher_id: '' }
]);
}}>
  <AiOutlinePlus /> Assign Subject
</button>
}
</div>
{/* flex ends */}

<div className='d-md-flex d-sm-flex d-block mt-3'>

                  <div className="mb-4 w-100 me-3">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
                    <select
                      className="profile-input"
                      value={selectedClassId}
                      onChange={(e) => setSelectedClassId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
</div>
                  </div>

                  {/* Select Section */}
                  <div className="mb-4 w-100">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Section*</label>
<select
  className="profile-input"
  value={selectedSection}
  onChange={(e) => setSelectedSection(e.target.value)}
  required
>
  <option value="">-- Select Section --</option>
  {availableSections.map((section, idx) => (
    <option key={idx} value={section}>
      {section}
    </option>
  ))}
</select>

                    </div>
                  </div>


</div>
{/* flex ends */}

<div className='text-end'>
<button className='profile-btn2' onClick={() => fetchAssignSubject()}>
  <AiOutlineSearch /> Search
</button>
</div>

</div>
{/* profile card ends */}


{showForm && assignments.length > 0 && (
  <>
  <div className='d-flex justify-content-between my-3 px-2'>
              <span className="profile-heading align-content-center">Assign Subject Create</span>
    {/* Add More button */}
    <button
      type="button"
      className="profile-btn2 px-2 py-1 rounded-circle"
      onClick={handleAddAssignment}
    >
      <FaPlus />
    </button>
</div>
{/* flex ends */}

  <div className="profile-card">
    {assignments.map((assignment, index) => (
      <div key={index} className='d-md-flex d-sm-flex d-block align-items-end'>

        {/* Subject Dropdown */}
        <div className="me-3 w-100 my-3">
          <div className='profile-input-area'>
            <label className="profile-badge">Select Subject*</label>
            <select
              className="profile-input"
              value={assignment.subject_id}
              onChange={(e) => handleAssignmentChange(index, 'subject_id', e.target.value)}
disabled={!!assignment.id}            >
              <option value="">-- Select Subject --</option>
              {subjects.map((subj) => (
                <option key={subj.id} value={subj.id}>
                  {subj.sub_name} &nbsp;&nbsp;---&nbsp;&nbsp; {subj.sub_code}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Teacher Dropdown */}
        <div className="me-3 w-100 my-3">
          <div className='profile-input-area'>
            <label className="profile-badge">Select Teacher*</label>
            <select
              className="profile-input"
              value={assignment.teacher_id}
              onChange={(e) => handleAssignmentChange(index, 'teacher_id', e.target.value)}
disabled={!!assignment.id}            >
              <option value="">-- Select Teacher --</option>
              {emp.map((teacher) => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.name} &nbsp;&nbsp;--- &nbsp;&nbsp; {teacher.user_id}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Remove button */}
        {/* {assignments.length > 1 && (
          <button
            type="button"
            className="btn btn-danger py-1 rounded-circle px-2 mb-4"
            onClick={() => handleRemoveAssignment(index)}
          >
            <FaMinus />
          </button>
        )} */}
        {assignment.id ? (
  // Always show remove button for prefilled assignments
  <button
    type="button"
    className="btn btn-danger py-1 rounded-circle px-2 mb-4"
    onClick={() => handleRemoveAssignment(index)}
  >
    <FaMinus />
  </button>
) : (
  // Show remove button only if more than one assignment for new ones
  assignments.length > 1 && (
    <button
      type="button"
      className="btn btn-danger py-1 rounded-circle px-2 mb-4"
      onClick={() => handleRemoveAssignment(index)}
    >
      <FaMinus />
    </button>
  )
)}

      </div>
    ))}


    {/* Submit button */}
    <button className='profile-btn mt-2' onClick={handleSubmit}>
      <FaCheck /> Save
    </button>
  </div>
  </>
)}
{/* profile card ends */}



</div>
</section>
    </>
  )
}

export default AssignSubjects
